export const IGNORED_ROLE_POPULATIONS = ['CRV ENT', 'DCR'];

export class EmployeeRoleEnum {
    public static readonly AC = new EmployeeRoleEnum('AC', 'AC');
    public static readonly CA_ICS_HBE = new EmployeeRoleEnum('CA_ICS_HBE', 'CA_ICS_HBE');
    public static readonly CA_ICS_VT = new EmployeeRoleEnum('CA_ICS_VT', 'CA_ICS_VT');
    public static readonly CC = new EmployeeRoleEnum('CC', 'DISCO');
    public static readonly CCL = new EmployeeRoleEnum('CCL', 'DISCO');
    public static readonly CSC = new EmployeeRoleEnum('CSC', 'DISCO');
    public static readonly CSL = new EmployeeRoleEnum('CSL', 'DISCO');
    public static readonly DC = new EmployeeRoleEnum('DC', 'DISCO');
    public static readonly ASC = new EmployeeRoleEnum('ASC', 'DISCO');
    public static readonly CRV_PRO = new EmployeeRoleEnum('CRV_PRO', 'AC');

    public readonly eForceRole: string;
    public readonly pricingRole: string;

    constructor(eForceRole: string, pricingRole: string) {
        this.eForceRole = eForceRole;
        this.pricingRole = pricingRole;
    }

    isDisco(): boolean {
        return this.pricingRole === 'DISCO';
    }

    isAC() {
        return this.pricingRole === "AC";
    }

    isCA_ICS_VT() {
        return this.pricingRole === "CA_ICS_VT";
    }

    public static getEmployeeRoleEnumFromEforceRole(role: string): EmployeeRoleEnum {
        switch (role) {
            case 'AC':
                return EmployeeRoleEnum.AC
            case 'CA_ICS_HBE':
                return EmployeeRoleEnum.CA_ICS_HBE
            case 'CA_ICS_VT':
                return EmployeeRoleEnum.CA_ICS_VT
            case 'CC':
                return EmployeeRoleEnum.CC
            case 'CCL':
                return EmployeeRoleEnum.CCL
            case 'CSC':
                return EmployeeRoleEnum.CSC
            case 'CSL':
                return EmployeeRoleEnum.CSL
            case 'DC':
                return EmployeeRoleEnum.DC
            case 'ASC':
                return EmployeeRoleEnum.ASC
            case 'CRV_PRO':
                return EmployeeRoleEnum.CRV_PRO
        }
    }
}
